import {onFind} from "@elements/init-modules-in-scope";
import {on, trigger, addClass, removeClass, find, findIn, findAllIn, closest, removeAttribute, setAttribute} from "@elements/dom-utils";
import axios from "axios";
import * as terracePlannerOutlineResize from "./outlineResize";
import {rotate} from "./outlineGadgets";
import {scale} from "./outlineScaler";
import {disableLoadingOverlay, enableLoadingOverlay} from "../applicationLoading";
import {setTabData, updateTab, unCompleteTab, completeTab, switchTab, loadPanelContents, visualizeCompleteness} from "../tabManager";
import {clearHistory} from '../changeHistory';
import TerracePlanner from "../index";
import * as plankPatternButtonBars from "../plankPattern/plankPatternButtonBars";
import * as terracePlannerOutlineInputDependencies from "./outlineInputDependencies";

let outlineUrl = window.location.protocol + '//' + window.location.hostname + '/r/terraceplanner/outline/',
    directionButtons, rotateButton, outlineCompleteButton, outlineBuilderNode

/**
 * handles UI interactions in the outline tab
 *
 * @type {{init}}
 */
let polygonPatternClasses = ['svg-fill__pattern--horizontal', 'svg-fill__pattern--vertical'];

export function init() {
    // onFind('.js-planner', function (element) {
    //     planer = element;
    //
    //     bindStaticListeners(TerracePlanner.element);
    // });
}

/**
 * listener to initiate an XHR to get a new outline based the selected shape
 * @param event MouseEvent
 */
export function selectShapeListener(input) {
    // let parentLink = $(event.target).closest('.tp-content__outline__shape');
    let shape = input.getAttribute('data-shape');
    let constellation = input.getAttribute('data-constellation');

    enableLoadingOverlay();
    // constellationLoadingAnimation(100, -72000);

    axios({
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        url: outlineUrl + 'shape?shape=' + shape + '&constellation=' + constellation,
        responseType: 'json'
    }).then(({data}) => {
        const newEL = document.createRange().createContextualFragment(data);
        findIn('.js-planner__builder', TerracePlanner.element).innerHTML = '';
        findIn('.js-planner__builder', TerracePlanner.element).append(newEL);

        // findIn('.js-planner__builder', TerracePlanner.element).innerHTML = data;
        clearHistory('outline');
        disableLoadingOverlay();

        bindConstellationAreaListeners();
        bindShapeAreaListeners();

        //init outline functions after content change
        if (TerracePlanner.tabConfig['outline'].active === true) {
            plankPatternButtonBars.init();
            terracePlannerOutlineResize.init();
            terracePlannerOutlineInputDependencies.init();
        }
    });
}


/**
 * temporarily disables css transitions on the outline svg to instantly apply transformations
 *
 * @param duration Number
 */
export function pauseTransitions(duration) {
    let styleTag = document.createElement('style');
    styleTag.innerText = '#outlineSvg, #selectedConstellation svg, #outlineSvg * {transition: unset;}';
    document.body.appendChild(styleTag);

    window.setTimeout(function () {
        styleTag.parentNode.removeChild(styleTag);
    }, duration || 200); // wonky af, try not to use
}

/**
 * on success callback for selectConstellationListener, sets the received HTML to the parent container for the outline
 * and applies the previous rotation
 *
 * @param data
 */
export function constellationSuccess(data) {

}

/**
 * listener to initiate an XHR to get a new constellation while keeping input values.
 * sets the selected constellation's svg to div#selectedConstellation
 * @param event MouseEvent
 */
export function selectConstellationListener(item) {
    let shape = item.getAttribute('data-shape');
    let constellation = item.getAttribute('data-constellation');

    enableLoadingOverlay();

    axios({
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        url: outlineUrl + 'constellation?shape=' + shape + '&constellation=' + constellation,
        responseType: 'json'
    }).then((data) => {
        const newEL = document.createRange().createContextualFragment(data.data);
        findIn('.js-planner__svg', TerracePlanner.element).innerHTML = '';
        findIn('.js-planner__svg', TerracePlanner.element).append(newEL);

        terracePlannerOutlineResize.init();
        bindConstellationAreaListeners();

        pauseTransitions(200);
        rotateOutline(0); // apply the rotation stored as HTML attribute in the container

        disableLoadingOverlay();
    });

    let selectedConstellation = closest('.js-planner__constellation', item);
    findIn('.js-planner__constellation-active-placeholder', selectedConstellation).innerHTML = findIn('.js-planner__constellation-placeholder', item).innerHTML;
    setAttribute('data-constellation', item.getAttribute('data-constellation'), findIn('.js-planner__constellation-active', selectedConstellation));
    selectedConstellation.getAttribute('constellation', item.getAttribute('data-constellation'));
}

/**
 * returns a svgNode's current svg-fill__pattern--* class
 * @see polygonPatternClasses
 *
 * @param svgNode Element
 */
export function getPatternClass(svgNode) {
    let classList = svgNode.getAttribute('class').split(' '); // IE 10 & 11 don't support classList

    for (let entry in classList) {
        if (!classList.hasOwnProperty(entry)) {
            break;
        }

        let cssClass = classList[entry];

        if (/svg-fill__pattern--/.test(cssClass)) {
            return cssClass;
        }
    }

    return '';
}

/**
 * listener to toggle the direction of symbolized planks in the outline
 *
 * @param event MouseEvent
 */
export function toggleDirectionListener(button) {
    let rect = find(button.getAttribute('data-rect-id'));
    let cssClass = getPatternClass(rect);
    let index = polygonPatternClasses.indexOf(cssClass);

    if (++index >= polygonPatternClasses.length) {
        index = 0;
    }

    // rect.removeClass(cssClass);
    removeClass(cssClass, rect);
    addClass(polygonPatternClasses[index], rect);
    // rect.addClass(polygonPatternClasses[index]);
}

/**
 * rotates the svgs in the constellations drop down
 * used to reflect the rotation of the outline
 *
 * @param angleDeg Number
 */
export function rotateConstellations(angleDeg) {
    // let constellations = $('#selectedConstellation svg, .tp-content__outline__constellation svg');
    let constellations = findAllIn('.js-planner__constellation svg', TerracePlanner.element);
    constellations.map((constellation) => setAttribute('transform', 'rotate(' + angleDeg + ')', constellation));
    // constellations.map((constellation) => constellation.transform = 'rotate(' + angleDeg + 'deg)');
    // constellations.css('transform', 'rotate(' + angleDeg + 'deg)');
}

/**
 * rotates the outline by adding angleDeg to its current rotation
 * the current rotation is stored as an HTML attribute in the svg's parent so it isn't reset when a new constellation is loaded
 * initiates rotation of gadgets in the opposite direction so they appear to be unaffected by the rotation
 * @see rotate
 *
 * @param angleDeg Number : angle in degrees
 */
export function rotateOutline(angleDeg) {
    let outline = find('#outlineSvg');
    let outlineAngle = (Number(closest('.js-planner__svg-container', outline).getAttribute('data-rotated')) + angleDeg) | 0;

    // rotate() makes the direction of the animation more controllable than matrix()
    // as negative values (in deg) always produce counterclockwise rotation
    setAttribute('transform', 'rotate(' + outlineAngle + ')', outline);

    closest('.js-planner__svg-container', outline).getAttribute('data-rotated', outlineAngle);
    setAttribute('data-rotated', outlineAngle, closest('.js-planner__svg-container', outline));

    let gadgetsAngle = -1 * outlineAngle; //gadgets need to be rotated the other way
    rotate(gadgetsAngle, TerracePlanner.dimensionLetters);
    rotate(gadgetsAngle, TerracePlanner.directionButtons);
    rotateConstellations(outlineAngle);
}

/**
 * iterates over all currently present inputs and returns their values as an object
 * That way, the values at a specific time can be stored
 *
 * @returns {{}}
 */
export function getDimensionValues() {
    let inputs = findAllIn('.js-planner__dimension-input', TerracePlanner.element);
    let dimensions = {};

    inputs.map((element) => {
        dimensions[element.id] = parseFloat(element.value.replace(',', '.')) * 100;
    })

    return dimensions;
}

/**
 * takes an Object containing multiple dimensions to apply to inputs with the same ids
 *
 * @param dimensions Object {dimensionId: Number}
 */
export function setDimensionValues(dimensions) {
    for (let dimension in dimensions) {
        console.log('setDimensionValues', dimension)
        let input = document.getElementById(dimension);

        if(! dimensions.hasOwnProperty(dimension) || null === input) {
            continue;
        }

        input.value = dimensions[dimension] / 100;
        trigger('input', input);
    }
}

/**
 * takes the svg in containerNode and strips all Ids so the copied one isn't modified anymore
 * by other modules
 * Also removes direction buttons and letters
 * @param containerNode
 */
//todo not needed ?
// export function stripImage (containerNode) {
//     findIn('[id]:not(pattern)', containerNode).setAttribute('id', '');
//     // containerNode.find('[id]:not(pattern)').attr('id', '');
//
//     console.log(findAllIn('.svg-outline__direction, .svg-outline__letter', containerNode))
//     findAllIn('.svg-outline__direction, .svg-outline__letter', containerNode).map((element) => {
//         element.parentNode.removeChild(element);
//     });
//     // containerNode.find('.svg-outline__direction, .svg-outline__letter').each(function (index, element) {
//     //     element.parentNode.removeChild(element);
//     // });
// }

/**
 * adds a copy of the current #outlineSvg and its calculated area to the tab's item in the navigation bar,
 * completes the tab and switches to the next
 * @see TerracePlanner.outlineAreaCalculation
 */
export function updateOutline() {
    let area = outlineAreaCalculation().toFixed(2); // cm² -> m²

    let text = area.replace('.',',') + ' m²';
    let imageContainer = findIn('.js-planner__svg-container', TerracePlanner.element);

    let plankDirections = [];
    if (imageContainer) {
        findAllIn('.svg-outline__rect', imageContainer).map((element) => plankDirections.push(getPatternClass(element).split('--')[1]))
    }

    setTabData('outline', {
        shape: findIn('.js-planner__layout-input:checked', TerracePlanner.element).getAttribute('data-shape'),
        constellation: findIn('.js-planner__constellation-active', TerracePlanner.element).getAttribute('data-constellation'),
        dimensions: getDimensionValues(),
        rotation: Number(imageContainer.getAttribute('data-rotated')) % 360,
        plankDirections: plankDirections
    });

    updateTab('outline', text);
    unCompleteTab('summary');
}


function outlineAreaCalculation() {
    let currentShape = findIn('.js-planner__layout-input:checked', TerracePlanner.element) ? findIn('.js-planner__layout-input:checked', TerracePlanner.element).getAttribute('data-shape') : undefined;
    let calc;

    console.log(currentShape)

    switch (currentShape) {
        case 'Rectangle':
            /**
             * in letters: A * B
             * @returns {number}
             */
            let widthValue = find('input#width').value;
            let lengthValue = find('input#length').value;
            calc = Number(widthValue.replace(',','.')) * Number(lengthValue.replace(',','.'))
            break;
        case 'LShape':
            let lShapeUpperWidth = find('input#upperWidth').value;
            let lShapeLowerWidth = find('input#lowerWidth').value;
            let lShapeLength = find('input#length').value;
            let lShapeLowerLength = find('input#lowerLength').value;
            calc = Number(lShapeUpperWidth.replace(',','.')) * Number(lShapeLength.replace(',','.'))
                + Number(lShapeLowerWidth.replace(',','.')) * Number(lShapeLowerLength.replace(',','.'));
            break;
        case 'TShape':
            let tShapeCenterWidth = find('input#centerWidth').value;
            let tShapeWidth = find('input#width').value;
            let tShapeLowerLength = find('input#lowerLength').value;
            let tShapeUpperLength = find('input#upperLength').value;
            calc = Number(tShapeCenterWidth.replace(',','.')) * Number(tShapeUpperLength.replace(',','.'))
                + Number(tShapeLowerLength.replace(',','.')) * Number(tShapeWidth.replace(',','.'));
            break;
        case 'UShape':
            let uShapeLength = find('input#length').value;
            let uShapeLowerLength = find('input#lowerLength').value;
            let uShapeUpperLength = find('input#upperLength').value;
            let uShapeInnerWidth = find('input#innerWidth').value;
            let uShapeLowerInnerWidth = find('input#lowerInnerWidth').value;
            let uShapelowerOuterWidth = find('input#outerWidth').value;
            calc = Number(uShapeLowerInnerWidth.replace(',','.')) * Number(uShapeLowerLength.replace(',','.'))
                + Number(uShapeInnerWidth.replace(',','.')) * Number(uShapeUpperLength.replace(',','.'))
                + Number(uShapelowerOuterWidth.replace(',','.')) * Number(uShapeLength.replace(',','.'));
            break;
        case 'OShape':
            let oShapeLeftOuterWidth = find('input#leftOuterWidth').value;
            let oShapeRightOuterWidth = find('input#rightOuterWidth').value;
            let oShapeLength = find('input#length').value;
            let oShapeLowerLength = find('input#lowerLength').value;
            let oShapeUpperLength = find('input#upperLength').value;
            let oShapeInnerWidth = find('input#innerWidth').value;
            calc = Number(oShapeLeftOuterWidth.replace(',','.')) * Number(oShapeLength.replace(',','.'))
                + Number(oShapeInnerWidth.replace(',','.')) * Number(oShapeUpperLength.replace(',','.'))
                + Number(oShapeInnerWidth.replace(',','.')) * Number(oShapeLowerLength.replace(',','.'))
                + Number(oShapeRightOuterWidth.replace(',','.')) * Number(oShapeLength.replace(',','.'));

            break;
        default:
            calc = 0;
            break;
    }

    return calc;
}

/**
 * completes the tab and switches to the next, which normally is material, except if plankPattern is already
 * initialized, which requires jumping between that and this tab
 */
export function completeOutline() {
    if (TerracePlanner.tabConfig.plankPattern.initialized) {
        unCompleteTab('plankPattern');
        completeTab('outline', 'plankPattern');
    } else {
        completeTab('outline');
        switchTab('surface');
    }

    if(TerracePlanner.tabConfig.subStructure.initialized) {
        loadPanelContents('subStructure');
    }
}

/**
 * listener to complete the tab and switch to the next
 *
 * @param event
 */
export function outlineCompleteListener(event) {
    updateOutline();
    completeOutline();
}

/**
 * binds listeners on nodes that are not reloaded asynchronously, i.e. that only need a listener bound once
 * jQuery would bind a listener more than once, even if the same reference is passed, silly jQuery :D
 */
export function bindStaticListeners(element) {
    outlineCompleteButton = findIn('.js-planner__submit-outline', element);
    outlineBuilderNode = findIn('.js-planner__builder', element);

    if (outlineCompleteButton) {
        on('click', (evt) => outlineCompleteListener(evt), outlineCompleteButton);
    }
    // outlineCompleteButton.click(outlineCompleteListener);

    findAllIn('.js-planner__layout-input', element).map((input) => {
        on('change', (evt) => {
            if (input.checked) {
                selectShapeListener(input);
            }
        }, input);
    });
    // $('.list-layouts__item').click(selectShapeListener);

    //todo ist jetzt in loadPanelContents
    //
    // if (TerracePlanner.tabConfig.outline.complete) {
    // updateOutline();
    // visualizeCompleteness('outline');
    // }
}

/**
 * binds event listeners to elements (re)loaded asynchronously for every new shape
 */
export function bindShapeAreaListeners() {
    onFind('.js-planner__rotate', function (button) {
        rotateOutline(0);
        const handleClick = () => rotateOutline(-90);

        button.addEventListener('click', handleClick);

        return () => {
            button.removeEventListener('click', handleClick);
        };
    })

    onFind('.js-planner__constellation-select', function (button) {
        const handleClick = () => selectConstellationListener(button);

        button.addEventListener('click', handleClick);

        return () => {
            button.removeEventListener('click', handleClick);
        };
    })
}

/**
 * binds event listeners to elements (re)loaded asynchronously for every new constellation
 */
export function bindConstellationAreaListeners() {
    onFind('.js-planner__svg-direction-rotate', function (directionButton) {
        const handleClick = () => {
            toggleDirectionListener(directionButton)
        };

        directionButton.addEventListener('click', handleClick);

        return () => {
            directionButton.removeEventListener('click', handleClick);
        };
    });
    scale();
}